import {
  AbstractControl,
  UntypedFormControl,
  FormGroupDirective,
  NgForm,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { UiValidatorType } from './ui-validator-type';
import { UiValidator } from './ui-validator.dto';
import { FieldConfigDTO } from '../../system/system-dtos';

export interface ValidatorConfig {
  angularValidator: (u: UiValidator) => ValidatorFn;
  message: (u: UiValidator) => string;
  condition: (fc: AbstractControl) => boolean;
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  static messageMap: { [key: string]: ValidatorConfig } = {};

  static initialize() {
    MyErrorStateMatcher.messageMap[UiValidatorType.MAX] = {
      angularValidator: (u: UiValidator) => Validators.max(u.longValue),
      message: (u: UiValidator) => `Max value is ${u.longValue}`,
      condition: (fc: AbstractControl) => fc.hasError('max'),
    };
    MyErrorStateMatcher.messageMap[UiValidatorType.MIN] = {
      angularValidator: (u: UiValidator) => Validators.min(u.longValue),
      message: (u: UiValidator) => `Min value is ${u.longValue}`,
      condition: (fc: AbstractControl) => fc.hasError('min'),
    };
    MyErrorStateMatcher.messageMap[UiValidatorType.NOT_NULL] = {
      angularValidator: (u: UiValidator) => Validators.required,
      message: (u: UiValidator) => 'Required field',
      condition: (fc: AbstractControl) => fc.hasError('required'),
    };
    MyErrorStateMatcher.messageMap[UiValidatorType.MIN_LENGTH] = {
      angularValidator: (u: UiValidator) => Validators.minLength(u.longValue),
      message: (u: UiValidator) => `Min length of field is ${u.longValue}`,
      condition: (fc: AbstractControl) => fc.hasError('minLength'),
    };
  }

  static convertToAngularValidators(field: FieldConfigDTO[]): ValidatorFn[] {
    let validators = [];
    if (field.length > 0 && field[0].validators) {
      validators = this.getValidators(field[0].validators);
    }
    return validators;
  }

  static getValidators(validators: UiValidator[]) {
    return validators.map((v) => MyErrorStateMatcher.messageMap[v.type].angularValidator(v));
  }

  static getMessageMap() {
    return this.messageMap;
  }

  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form;
    return !!(control && control.invalid && isSubmitted);
  }
}
MyErrorStateMatcher.initialize();
